import { createGlobalStyle } from "styled-components/macro";
import { GlobalStyleProps } from "../types/styles";

const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  html,
  body,
  #root {
    height: 100%;
    overflow-x: hidden;
  }

  body {
    background: ${(props) => props.theme.palette.background.default};
    margin: 0;
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }

  .MuiInputBase-root:after {
    border-bottom: solid 1px #ff0e2a;
  }

`;

export default GlobalStyle;
